<template>
  <router-view/>
</template>
<script>
  import './assets/css/main.css';
  import './assets/css/cutom.css';

  import { app as firebaseApp } from "./firebase";
  import {
  getToken,
  getMessaging,
  onMessage,
  deleteToken,
} from "firebase/messaging";
import { register as registerSW } from "register-service-worker";

export default {
  data: () => ({
    messaging: null,
    clientToken: null,
    statusMessage: null,
  }),

  async created() {
    this.messaging = getMessaging(firebaseApp);
    if (this.isSubscribed()) this.clientToken = await this.getSubscribedToken();
    await this.registerServiceWorker();
  },

  methods: {
    async registerServiceWorker() {
      let subscribeToken = this.subscribeToken;
      if ("Notification" in window && navigator.serviceWorker) {
        registerSW(`${process.env.BASE_URL}firebase-messaging-sw.js`, {
          ready(reg) {
            console.log("Service worker is Ready");
            // subsctibe to FCM
            subscribeToken(reg);
          },
          registered(reg) {
            console.log("Service worker has been registered.");
            setInterval(() => {
              reg.update();
            }, 1000 * 60 * 30); // 30 min checks
          },
          cached() {
            // console.log('Content has been cached for offline use.');
          },
          updatefound() {
            console.log("New content is downloading.");
          },
          updated(reg) {
            console.log("New content is available; please refresh.");
            document.dispatchEvent(
              new CustomEvent("swUpdated", { detail: reg.waiting })
            );
          },
          offline() {
            console.log("No internet connection found.");
          },
          error(error) {
            console.error("Error during service worker registration:", error);
          },
        });
      }
    },
    
    async subscribeToken(reg) {
      let vapidKey = this.messaging?.vapidKey; //process.env.VAPIDKEY;
      try {
        let token = await getToken(this.messaging, {
          vapidKey,
          serviceWorkerRegistration: reg,
        });

        console.log("Client token => ", token);
        localStorage.setItem("fcmlogistic-token", token);

        this.listenForegroundMessage(reg);
      } catch (err) {
        console.error(err);
        this.unsetSubscribedToken();
        console.log("Retry to subscribe");
      }
    },
    async unsubscribeToken() {
      try {
        let unsubscribe = await deleteToken(this.messaging);
        console.log("Subscribed  ", unsubscribe);
        // let res = await this.removeTokenFromServer(this.clientToken.uuid);
        // console.log("Unsubscribed from server", res.data);
        await this.unsetSubscribedToken();
      } catch (err) {
        console.error(err);
      }
    },
    async listenForegroundMessage(reg) {
      if (!reg)
        reg = await navigator.serviceWorker.getRegistration(
          `${process.env.BASE_URL}firebase-messaging-sw.js`
        );

      onMessage(this.messaging, (payload) => {
        console.log("Message received. ", payload);
        
        let { notification } = payload;

        if (notification && notification.title && notification.body) {
          const notificationTitle = notification.title || 'title';
          const notificationOptions = {
            body: notification.body || 'body',
          };

          new Notification(notificationTitle, notificationOptions);
        }
      });
    },
    isSubscribed() {
      let ct = localStorage.getItem("clientToken");
      console.log("Subscribed", !!ct);
      return !!ct;
    },
    setSubscribedToken({ data }) {
      this.clientToken = data;
      console.log("stored in localstorage", this.clientToken);
      localStorage.setItem("clientToken", JSON.stringify(this.clientToken));
    },
    unsetSubscribedToken() {
      this.clientToken = null;
      localStorage.removeItem("clientToken");
      console.log("removed from localstorage", this.clientToken);
    },
    async getSubscribedToken() {
      let ct = localStorage.getItem("clientToken");

      if (ct) return JSON.parse(ct);
      else return null;
    },
    removeTokenFromServer(uuid) {

      console.log("uuid", uuid);
      // return axios.delete("http://localhost:3000/api/fcm/token/delete/" + uuid);
    },
  },
}
</script>